export default __webpack_public_path__ + "play_video.9200b61cfe2690f6b632.png";